import React from 'react';
import { Clock, ThermometerSun, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-101">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-102">
        {/* Opening Hook */}
        <div className="prose prose-lg mx-auto text-slate-700 mb-16" data-id="element-103">
          <p className="text-xl sm:text-2xl font-medium leading-relaxed text-slate-900 mb-8 border-l-4 border-teal-500 pl-6" data-id="element-104">
            ¿Te despiertas a mitad de la noche empapada en sudor, con el corazón
            acelerado, incapaz de volver a dormir?
          </p>
          <p className="mb-6" data-id="element-105">
            Esa sensación de calor interno que nadie entiende, arruinando tus
            noches y tus días. No estás sola, y hay una solución que no requiere
            fármacos ni tratamientos complicados.
          </p>
        </div>

        {/* The Specific Problem */}
        <div className="bg-slate-50 rounded-3xl p-8 sm:p-12 border border-slate-100 shadow-sm" data-id="element-106">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-107">
            <Clock className="w-8 h-8 text-teal-600 mr-3" data-id="element-108" />
            La Pesadilla de las 3:00 AM
          </h3>

          <div className="space-y-6 text-lg text-slate-700" data-id="element-109">
            <p data-id="element-110">
              Cada noche, a las 3 o 4 de la mañana, sientes esa ola de calor que
              te saca del sueño profundo. Te levantas para quitarte las sábanas
              mojadas, cambiar de ropa, y para cuando intentas dormir de nuevo,
              ya es de día.
            </p>
            <p data-id="element-111">
              Al día siguiente, sobrevives con café, cansancio y frustración.
              Nada de lo que has probado te ha dado un alivio real.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10" data-id="element-112">
            <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm flex items-start" data-id="element-113">
              <ThermometerSun className="w-6 h-6 text-orange-500 mr-4 flex-shrink-0 mt-1" data-id="element-114" />
              <div data-id="element-115">
                <h4 className="font-semibold text-slate-900 mb-2" data-id="element-116">
                  Calor Interno
                </h4>
                <p className="text-sm text-slate-600" data-id="element-117">
                  Esa sensación de fuego que sube desde el pecho hasta la cara.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-slate-100 shadow-sm flex items-start" data-id="element-118">
              <BatteryWarning className="w-6 h-6 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-119" />
              <div data-id="element-120">
                <h4 className="font-semibold text-slate-900 mb-2" data-id="element-121">
                  Agotamiento
                </h4>
                <p className="text-sm text-slate-600" data-id="element-122">
                  Despertar cansada antes de que empiece el día.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}